import { Component, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationStart } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-th-modal',
  templateUrl: './th-modal.component.html',
  styleUrls: ['./th-modal.component.css'],
})
export class THModalComponent implements OnChanges {
  @Input() openModal: boolean;
  @Input() selectedConcept: any;
  @Input() title: any;
  @Output() modalClosed = new EventEmitter<void>();
  modalContent = '';
  @ViewChild('thModal') thModal: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedConcept) {
      this.modalContent = JSON.stringify(this.selectedConcept, null, 2);
    }
    if (changes['openModal'] && changes['openModal'].currentValue) {
      this.openThModal();
    }
  }

  openThModal() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        this.modalService.dismissAll();
      }
    });
    const modalRef = this.modalService.open(this.thModal, { ariaLabelledBy: 'modal-title', size: 'lg', backdrop: 'static' });
    modalRef.result.then(
      (result) => {
        this.modalClosed.emit();
      },
      (reason) => {
        this.modalClosed.emit();
      },
    );
  }
}
